import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';

import './twoPage5.scss';

function TwoPage5(props) {
  const { setCurrentPage, currentFooter } = props;

  return (
    <>
      <div className="growth-page growth-page--5">
        <div className="growth-page__row">
          <h1 className="growth-page__title _title _growth-anim">
            Масштабные обновления: от доставки до приложения
          </h1>
        </div>
        <div className="growth-page__row growth-page__row--1">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Март</span>
            <span className="growth-page__year">2016</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            &laquo;Авито&raquo; тестирует доставку товаров
          </h2>
        </div>
        <div className="growth-page__row growth-page__row--2">
          <div className="growth-page__col">
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-5-1.png"
                  srcSet="img/two/growth-page-5-1.png 1x, img/two/growth-page-5-1@2x.png 2x"
                  alt="img"
                  className="_growth-anim"
                />
              </div>
              <p className="growth-page__caption _growth-anim _growth-anim--fade">
                Фото со&nbsp;страницы в&nbsp;социальной сети Product manager компании Юрий Палевич,
                первый товар с&nbsp;доставкой
              </p>
            </div>
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              С&nbsp;помощью сервиса пользователи могут продавать товары друг другу с&nbsp;доставкой
              и&nbsp;онлайн-переводом денежных средств. Доставляют заказы партнерские службы Авито.
              Для сдачи посылок стали доступны пункты приема отправлений.
            </p>
            <p className="growth-page__text _text _growth-anim">
              В&nbsp;отличие от&nbsp;ранее запущенного сервиса доставки для бизнеса, физическим
              лицам не&nbsp;нужно заниматься в&nbsp;офлайне подключением платежей.
              В&nbsp;С2С-сервисе все функции онлайн.
            </p>
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                Все данные пользователей теперь хранятся исключительно на территории России.
              </p>
              <p className="note__text _small-text">
                300 серверов для этого перевезли в московский дата-центр из Стокгольма.
              </p>
            </div>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--3">
          <div className="growth-page__wrap-img">
            <div className="growth-page__img _growth-anim">
              <img
                src="img/two/growth-page-5-2.png"
                srcSet="img/two/growth-page-5-2.png 1x, img/two/growth-page-5-2@2x.png 2x"
                alt="img"
                className="_growth-anim"
              />
            </div>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--4">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Июнь</span>
            <span className="growth-page__year">2016</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            Масштабный запуск &laquo;Автотеки&raquo;
          </h2>
        </div>
        <div className="growth-page__row growth-page__row--5">
          <div className="growth-page__col">
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-5-3.png"
                  srcSet="img/two/growth-page-5-3.png 1x, img/two/growth-page-5-3@2x.png 2x"
                  alt="img"
                  className="_growth-anim"
                />
              </div>
              <p className="growth-page__caption _growth-anim--fade">
                Владимир Правдивый становится гендиректором компании, шведы-основатели отходят
                от&nbsp;управления.
              </p>
            </div>
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                {' '}
                &laquo;Авито&raquo; быстро растет: штат достигает почти
              </p>
              <p className="note__main">1,3 тыс сотрудников</p>
            </div>
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              Запускается &laquo;Автотека&raquo;&nbsp;&mdash; совместная база данных
              &laquo;Авито&raquo; и&nbsp;крупнейших автодилеров страны&nbsp;&mdash;
              &laquo;Автомира&raquo;, Genser, &laquo;Ключавто&raquo;, &laquo;Независимости&raquo;,
              &laquo;Рольфа&raquo; и&nbsp;&laquo;ТрансТехСервиса&raquo;. &laquo;Автотека&raquo;
              помогает покупателям узнать всю историю автомобиля по&nbsp;VIN-номеру, включая данные
              о&nbsp;пробеге и&nbsp;техосмотрах.
            </p>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--6">
          <div className="growth-page__wrap-img">
            <div className="growth-page__img _growth-anim">
              <img
                src="img/two/growth-page-5-4.png"
                srcSet="img/two/growth-page-5-4.png 1x, img/two/growth-page-5-4@2x.png 2x"
                alt="img"
                className="_growth-anim"
              />
            </div>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--7">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Декабрь</span>
            <span className="growth-page__year">2016</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            &laquo;Авито&raquo; обновил дизайн мобильного приложения
          </h2>
        </div>
        <div className="growth-page__row growth-page__row--8">
          <div className="growth-page__col">
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-5-5.png"
                  srcSet="img/two/growth-page-5-5.png 1x, img/two/growth-page-5-5@2x.png 2x"
                  alt="img"
                  className="_growth-anim"
                />
              </div>
            </div>
          </div>
          <div className="growth-page__col">
            <div className="note growth-page__note">
              <p className="note__text _text _growth-anim">
                50% пользователей заходят с&nbsp;мобильных устройств.
              </p>
            </div>
            <div className="note growth-page__note">
              <p className="note__text _text _growth-anim">
                На&nbsp;конец 2016 года свои объявления на&nbsp;платформе разместили 10&nbsp;млн
                продавцов
              </p>
            </div>
          </div>
        </div>
        <div className="growth-page__footer _footer">
          <div className="growth-page__footer-col"></div>
          <div className="growth-page__footer-col">
            <div
              className={cn("growth-page__footer-item", currentFooter === 6 && "growth-page__footer-item--hide")}
              onClick={() => setCurrentPage({ status: true, el: currentFooter })}>
              <div className="growth-page__footer-img">
                <img
                  src={`img/two/growth-page-footer-${currentFooter}.png`}
                  srcSet={`img/two/growth-page-footer-${currentFooter}.png 1x, img/two/growth-page-footer-${currentFooter}@2x.png 2x`}
                  alt="img"
                />
              </div>
              <span className="growth-page__footer-year">
                {currentFooter === 1 && '2012'}
                {currentFooter === 2 && '2013'}
                {currentFooter === 3 && '2014'}
                {currentFooter === 4 && '2015'}
                {currentFooter === 5 && '2016'}
                {currentFooter === 6 && '2017 - 2022'}
              </span>
              <h3 className="growth-page__footer-title">
                {currentFooter === 1 && 'Сколько стоит ваш беспорядок 2.0'}
                {currentFooter === 2 && 'Объединение Avito, Slando и OLX'}
                {currentFooter === 3 && 'Всероссийский рейтинг автодилеров'}
                {currentFooter === 4 && 'Участник площадки — вся страна'}
                {currentFooter === 5 && 'Масштабные обновления: от доставки до приложения'}
                {currentFooter === 6 && '«Авито» сегодня'}
              </h3>
            </div>
            <div className={cn("growth-page__footer-item", currentFooter === 6 && "growth-page__footer-item--full")} onClick={() => setCurrentPage({ status: true, el: 6 })}>
              <div className="growth-page__footer-img">
                <img
                  src={`img/two/growth-6.png`}
                  srcSet={`img/two/growth-6.png 1x, img/two/growth-6@2x.png 2x`}
                  alt="img"
                />
              </div>
              <span className="growth-page__footer-year">2017-2022</span>
              <h3 className="growth-page__footer-title">«Авито» сегодня</h3>
            </div>
          </div>
          <div className="growth-page__footer-col"></div>
        </div>
      </div>
    </>
  );
}

export default TwoPage5;
